import { Box, Stack, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { onboardingTokens } from "../../theme";
import { t } from "../../../../locales/t";

const NAMED = 2;

/**
 * Tells a member their learning path builds on sectors they already chose, so
 * the skills screen does not ask again. Names at most two and counts the rest;
 * the caller resolves ids to labels.
 *
 * @param {object} props
 * @param {string[]} props.sectors  labels, already resolved, in the member's own order
 */
const LearningPathCard = ({ sectors = [] }) => {
  const named = sectors
    .slice(0, NAMED)
    .join(t("onboarding.subflow.skills.and"));
  const rest = sectors.length - NAMED;

  const basis =
    sectors.length === 0
      ? t("onboarding.subflow.skills.basisGeneric")
      : t("onboarding.subflow.skills.basisNamed", {
          sectors:
            rest > 0
              ? t("onboarding.subflow.skills.andMore", { named, count: rest })
              : named,
        });

  return (
    <Stack
      direction="row"
      gap={1.5}
      data-testid="learning-path-card"
      sx={{
        p: 2,
        borderRadius: onboardingTokens.radius,
        backgroundColor: onboardingTokens.lightTeal,
        border: `1.5px solid ${onboardingTokens.teal}`,
      }}
    >
      <Box
        aria-hidden
        sx={{
          flexShrink: 0,
          width: 36,
          height: 36,
          borderRadius: 1.5,
          display: "grid",
          placeItems: "center",
          backgroundColor: onboardingTokens.teal,
          color: "primary.contrastText",
        }}
      >
        <CheckIcon fontSize="small" />
      </Box>

      <Box>
        <Typography sx={{ fontWeight: 700, fontSize: "0.9375rem", mb: 0.25 }}>
          {t("onboarding.subflow.skills.cardHeading")}
        </Typography>
        <Typography
          sx={{
            fontSize: "0.8125rem",
            lineHeight: 1.6,
            color: onboardingTokens.mutedForeground,
          }}
        >
          {basis}
        </Typography>
      </Box>
    </Stack>
  );
};

export default LearningPathCard;
